<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('p-super-admin')" class="admin-superpro">
      <div class="mb-2 p-2 border-bottom border-light">
        <h5 class="font-weight-light">
          <span><i class="fa-light fa-circle-dollar-to-slot"></i></span>
          Cadastrar Crédito
        </h5>
      </div>

      <Loading v-if="isLoading" class="loading" loadingText="Carregando..." />
      <b-form v-else>
        <b-form-row v-if="put_credito.length == 0">
          <b-col cols="12" md="6" lg="4" class="mt-4 mt-lg-3 form-group">
            <label for="input-idUser">ID do Usuário: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" type="text" placeholder="ID" v-model.trim="tempIdUsuario"
                @input="updateIdUsuario"></b-form-input>
              <b-input-group-append class="append">
                <i class="fa-regular fa-user"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="mt-4 mt-lg-3 form-group">
            <label for="input-idUser">Valor: <span class="text-danger">*</span></label>
            <b-input-group>
              <input class="form-control form-control-sm" size="sm" :value="formattedCredito" @keydown="cannotExcluse"
                @input="updateCredito" ref="creditoInput" />
              <b-input-group-append class="append">
                <i class="fa-regular fa-brazilian-real-sign"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" lg="4"
            class="mt-2 mt-md-4 mt-lg-3 d-flex align-items-center justify-content-center justify-content-lg-start">
            <b-button class="shadow-none btn-primary border-primary w-auto"
              @click="pos_credito_user">Confirmar</b-button>
          </b-col>
        </b-form-row>
        <b-form-row v-else>
          <b-col cols="12" md="4" class="mt-4 mt-lg-3 form-group">
            <label for="input-idUser">ID do Usuário: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" type="text" placeholder="ID" v-model.trim="tempIdUsuario"
                @input="updateIdUsuario"></b-form-input>
              <b-input-group-append class="append">
                <i class="fa-regular fa-user"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="4" class="mt-4 mt-lg-3 form-group">
            <label for="input-idUser">Valor: <span class="text-danger">*</span></label>
            <b-input-group>
              <input class="form-control form-control-sm" size="sm" :value="formattedCredito" @keydown="cannotExcluse"
                @input="updateCredito" ref="creditoInput" />
              <b-input-group-append class="append">
                <i class="fa-regular fa-brazilian-real-sign"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="4" class="mt-4 mt-lg-3 d-flex align-items-center">
            <b-button class="shadow-none btn btn-primary border-primary w-auto"
              @click="pos_credito_user">Confirmar</b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ApiService from '../../../../../common/api.service';
export default {
  components: { Loading: () => import('@/components/loading.vue') },
  data() {
    return {
      isLoading: false,
      spiner: false,
      put_credito: [],
      idUsuario: '',
      credito: 0,

      tempIdUsuario: '',

      fields: [
        { key: 'id', label: 'ID', class: 'text-center', tdAttr: { style: 'width: 10%' } },
        { key: 'message', label: 'Mensagem', tdAttr: { style: 'width: 40%' } },
        { key: 'activated', label: 'Status', class: 'text-center', tdAttr: { style: 'width: 5%' } },
        { key: 'error', label: '', tdAttr: { style: 'width: 45%' } },
      ],
    };
  },
  async mounted() {
    if (this.$route.query.loading) {
      this.isLoading = true;
      try {
        await this.fetchData();
      } catch (error) {
        console.error("ERROR loading data: ", error)
      } finally {
        this.isLoading = false
      }
    }
  },
  methods: {
    async fetchData() {
      await new Promise((resolve) => setTimeout(resolve, 1000))
    },
    validateFields() {
      this.showError = false
    },
    validateAndSubmit() {
      if (!this.isIdUsuarioValid || !this.isCreditoValid) {
        this.showError = true
        return;
      }
      this.pos_credito_user()
    },
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },

    pos_credito_user() {
      this.isLoading = true,
        this.idUsuario = this.tempIdUsuario;

      // this.spiner = true;
      ApiService.get('v1/callCredito', {
        idUsuario: this.idUsuario,
        credito: this.credito,
      })
        .then((response) => {
          this.put_credito = response;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateIdUsuario(event) {
      // Pegue o valor do input
      let inputValue = event.target.value;

      // Remova caracteres não numéricos
      let cleanValue = inputValue.replace(/[^\d]/g, '');

      // Atualize o valor
      this.tempIdUsuario = cleanValue;
    },

    updateCredito(event) {
      let value = event.target.value;

      // Remove todos os caracteres que não sejam dígitos
      value = value.replace(/\D/g, '');

      // Se não houver valor, define como 0
      if (!value) {
        this.credito = 0;
        return;
      } else {
        // Converte o valor digitado em centavos para o valor decimal correto
        this.credito = parseFloat(value) / 100;
      }
    },

    cannotExcluse(event) {
      // Se o valor for '0,00' e a tecla Backspace for pressionada, previna a ação
      const zeroValue = this.formattedCredito === '0,00';

      const isNumber = /[0-9]/.test(event.key);

      // Previne ações indesejadas se o valor for '0.00'
      if (zeroValue && (event.key === 'Backspace' || event.key === 'Delete')) {
        event.preventDefault();
      }

      if (!isNumber && event.key !== 'Backspace' && event.key !== 'Delete') {
        event.preventDefault();
      }
    }
  },
  computed: {
    mensagemModificada() {
      const cadastrarCredito = this.put_credito?.data?.creditoUser?.xml
      if (cadastrarCredito && cadastrarCredito.status?.msg === 'Consulta efetuada com sucesso!') {
        return 'Senha alterada com sucesso!'
      }

      return cadastrarCredito?.status?.msg || '-'
    },

    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },

    formattedCredito() {
      // Formata o valor de 'credito' como moeda brasileira (sem o símbolo 'R$')
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(this.credito);
    },

    formattedData() {
      if (!this.put_credito.data || !this.put_credito.data.creditoUser) {
        return [];
      }

      const colocarCredito = this.put_credito.data.creditoUser;

      if (colocarCredito && typeof colocarCredito === 'object') {
        return [{
          idUsuario: this.idUsuario,
          status: colocarCredito.status,
          erro: colocarCredito.erro,
          msg: colocarCredito.msg || 'Mensagem não disponível!'
          // mensagem: colocarCredito.msg,
          // saldo: creditoUsuario.xml?.dados?.saldo,
        }];
      }

      console.log('Dados formatados: ', data)
      return [];
    },

  },

};
</script>

<style scoped>
.fade-in-up {
  -webkit-animation: fadeIn 0.4s ease-in-out;
  -moz-animation: fadeIn 0.4s ease-in-out;
  -o-animation: fadeIn 0.4s ease-in-out;
  animation: fadeIn 0.4s ease-in-out;
}

.loading {
  height: 25vh;
}
</style>
